<template>
	<div class="pay_box">
		<div class="modelBox">
			<div class="payDialog">
				<div class="head lg-list-title">请输入支付密码</div>
				<div class="password" style="padding-bottom: 0;background: #ffffff;">
					<input v-model='inputPass' id='input' ref='myInput' type='text' autofocus="autofocus" maxlength='6' class='inputPass' />
					<form style="background: #ffffff">
						<input v-model='myPassword.myPassword1' type='password' maxlength='1' readonly="readonly" />
						<input v-model='myPassword.myPassword2' type='password' maxlength='1' readonly="readonly" />
						<input v-model='myPassword.myPassword3' type='password' maxlength='1' readonly="readonly" />
						<input v-model='myPassword.myPassword4' type='password' maxlength='1' readonly="readonly" />
						<input v-model='myPassword.myPassword5' type='password' maxlength='1' readonly="readonly" />
						<input v-model='myPassword.myPassword6' type='password' maxlength='1' readonly="readonly" />
					</form>
					<div class="tip" v-if="psdWrong">
						支付密码错误，请输入6位数字支付密码
					</div>
				</div>
				<div class="footer">
					<el-button type="primary" @click='cancel'>取 消</el-button>
					<el-button type="primary" @click='confirm'>确 定</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
    data() {
      return {
        inputPass: '',
        unbindForm: {
          pay_pass: ''
        },
        myPassword: {
          myPassword1: '',
          myPassword2: '',
          myPassword3: '',
          myPassword4: '',
          myPassword5: '',
          myPassword6: ''
        },
        psdWrong: false,
        unbind_rules: {
          pay_pass: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }]
        },
        options: [],
        pass: ''
      }
    },
    created() {
      this.showUp();
    },
    watch: {
      inputPass() {
        this.show();
        var patt = /^[0-9]*$/g;
        this.psdWrong = !patt.test(this.inputPass);//表单校验，输入错误时给出提示
      },
      dialogShow(){//确保每次打开窗口聚焦到输入框
        this.dialogShow ? this.showUp():""
      }
    },
    methods: {
      show() {//用户输入显示
        var myInputPass = this.inputPass;
        var arr = myInputPass.split('');
        var obj = this.myPassword;
        var index = 0;
        for (var i in obj) {
          obj[i] = arr[index];
          index++
        }
      },
      cancel() {
        this.inputPass = '';
        this.$emit("payBoxCancel")
      },
      confirm() {
        this.$requestApi.api.checkPayPassword({pay_password:this.inputPass}).then(res =>{
          this.inputPass = '';
          this.$emit('payBoxConfirm')
        })
          .catch(err =>{
            this.psdWrong = true
          })
      },
      showUp() {
        //保证焦点始终在表单上
        this.$nextTick(() => {
          this.$refs.myInput.focus();
        })
        window.addEventListener("mousedown", this.changeInput, {passive:false});
      },
      changeInput(e){
        if (e.target.id !== "input") {
          e.preventDefault()
        }
      }
    },
    destroyed() {
      window.removeEventListener("mousedown",this.changeInput,{passive:false})
    }
  }
</script>

<style scoped lang='less'>
	.pay_box {
		position: relative;
		z-index: 9999;
	}
	/* 支付对话框 */
	.pay_box .modelBox {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		margin: 0;
		background-color: rgba(0, 0, 0, .3);
	}

	.pay_box .payDialog {
		background-color: #fff;
		border: 1px solid #ccc;
		position: absolute;
		width: 400px;
		height: auto;
		top: 30%;
		left: 37.5%;
		z-index: 999;
	}

	.pay_box .payDialog .inputPass {
		position: absolute;
		z-index: -999;
		right: 25%;
		top: 40%;
		border: transparent;
		color:transparent;
		// touch-action: none;
	}
	.pay_box .payDialog .inputPass:focus{
		outline:none;
	}

	.pay_box .payDialog form {
		width: 100%;
		display: flex;
		height: 48px;
		justify-content: space-between;
	}

	.pay_box .payDialog form>input {
		width: 48px;
		height: 48px;
		text-align: center;
		display: block;
	}

	.pay_box .head,
	.pay_box .password,
	.pay_box .footer {
		padding: 20px 40px;
		text-align: center;
	}
	.pay_box .password>form>input {
		font-size: 30px;
		border: 1px solid #F4F4F4;
	}
	.pay_box .tip {
		color: #FF7C00;
		font-size: smaller;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/payBox.vue